import { ref, computed, reactive } from 'vue';
import { defineStore } from 'pinia';
import { filterEndpoint } from '../services/nopAPI';
import parseUrl from 'parse-url'

/* eslint-disable */
import { useSearchStore } from './search-store';

export const useFilterStore = defineStore('filter', () => {
  const siteFilters = ref({});
  const selectedFilters = reactive({});
  const urlQuery = reactive(parseUrl(window.location.href));

  const defaultProductFilter = '(term+field%3Ddocumenttype+%27product%27)';
  const defaultArticleFilter = '(or(term+field%3Ddocumenttype+%27blog%27)(term+field%3Ddocumenttype+%27resource%27)(term+field%3Ddocumenttype+%27catalog%27))';
  const defaultArticleReturnFields = 'return=tags,documenttype,name,shortdescription,documenttype_id,slug';

  const allFiltersAndOptions = reactive({});

  // state used for L2 pages:
  const categoryId = ref(0)
  const categoryName = ref('')
  const categoryDescription = ref('')
  const breadcrumbs = ref([])

  const isGenericSearch = computed(() => {
    return urlQuery.pathname.startsWith('/search');
  })
  const isCategorySearch = computed(() => {
    return categoryId.value == 0? false : true;
  })
  const isProductSearch = computed(() => {
    if (!isGenericSearch.value&&!isCategorySearch) return false;
    if (documentTypeFilters.value['product'] && documentTypeFilters.value['product'].length > 0) return true;
    return false;
  });

  const isArticleSearch = computed(() => {
    if (!isGenericSearch.value) return false;
    if (documentTypeFilters.value['article'] && documentTypeFilters.value['article'].length > 0) return true;
    return false;
  });

  const filtersInQuery = computed(() => {
    if (urlQuery.search) {
      return parseQueryForFilters(urlQuery.search)
    }
    return {}
  })

  const filterCount = computed(() => Object.keys(allFiltersAndOptions).length)

  async function establishFilters() {
    siteFilters.value = await getDynamicFilters();
  }

  const filterPills = computed(() => {
    /* eslint-disable */
    let pills = [];
    let filterKeys = Object.keys(selectedFilters);

    if (filterKeys.length != 0) {
      filterKeys.forEach((filterName) => {
        if (typeof selectedFilters[filterName] == 'object') {
          if (Array.isArray(selectedFilters[filterName])) {
            selectedFilters[filterName].forEach((item) => {
              if( allFiltersAndOptions[filterName][item]){
                pills.push({
                  filter: allFiltersAndOptions[filterName][item].key,
                  label: allFiltersAndOptions[filterName][item].label,
                  value: allFiltersAndOptions[filterName][item].value,
                });
              }
              if (isRangeFilter(item)) {
                const parsedItem = JSON.parse(item);
                if (parsedItem.length > 0) {
                  const minVlaue = parsedItem[0];
                  console.log(minVlaue)
                  const firstKey = Object.keys(allFiltersAndOptions[filterName])[0];
                  const key = allFiltersAndOptions[filterName][firstKey].key
                  const label = `${parsedItem[0]} - ${parsedItem[1]}`;
                  const value = item;
                  pills.push({
                    filter: key,
                    label: label,
                    value: value,
                  })
                }
              }
            });
          } else {
            if (selectedFilters[filterName] != null) {
              pills.push({
                filter: filterName,
                label: selectedFilters[filterName].label,
                value: selectedFilters[filterName].value,
              });
            }
          }
        } else if (typeof selectedFilters[filterName] == 'string') {
          const item = selectedFilters[filterName];
          item &&
            pills.push({
              filter: allFiltersAndOptions[filterName][item].key,
              label: allFiltersAndOptions[filterName][item].label,
              value: allFiltersAndOptions[filterName][item].value,
            });
        }
      });
    }
    return pills;
  });

  function loadFilterData(filterList) {
    filterList.forEach((filterData) => {
      let data = {};
      if (filterData.items.every((item) => typeof item === 'string')) {
        data = filterData.items.map((item) => {
          // {label:item, value:item, key:filterData.key}
          let context = {};
          const subject = { label: item, value: item, key: filterData.key };
          context = subject;
          context[item] = { ...subject };
          return context;
        });
      } else {
        data = filterData.items.map((item) => {
          // {label:item, value:item, key:filterData.key}
          let context = {};
          const subject = { ...item, key: filterData.key };
          context = subject;
          context[item.value] = { ...subject };
          return context;
        });
      }
      allFiltersAndOptions[filterData.key] = data.reduce((acc, item) => {
        if (!acc[item.value]) acc[item.value] = {};
        acc[item.value] = item;
        return acc;
      }, {});
    });
  }

  const appliedFilters = computed(() => {
    return filterPills.value.reduce((list, item) => {
      if (!list[item.filter]) list[item.filter] = [];
      list[item.filter].push(item.value);
      return list;
    }, {});
  });

  const formattedFilters = computed(() => {
    const lists = Object.keys(appliedFilters.value).map((key) => {
      let compiledList = ''
      if (!key === 'documenttype') {
        compiledList = appliedFilters.value[key].length > 1 ? 'or' : '';
        compiledList = appliedFilters.value[key].reduce((list, item) => {
          return (list += formatSearchField(key, item, 'term'));
        }, compiledList);

        return `(${compiledList})`;
      }
    })
    return lists.join('');
  });

  const defaultCategoryFilter = computed(() => {
    formatSearchField('documenttype', 'product', 'term')
    const category = categoryName.value.replace(/&/g, "%26")
    return `%28term+field%3Dl2_+%27${category}%27%29`
  });
  function formatSearchField(key, item, type='term') {
    if (type !== "range") {
      if(key === "material")
        key = "name";
      item = item && item.replace(/&/g, '%26');
      return `${type}+field%3D${key}+%27${item}%27`
    } else {
      return `${type}+field%3D${key}+${item}`
    }
  }

  function removePill(pill) {
    if (typeof selectedFilters[pill.filter] == 'object') {
      if (Array.isArray(selectedFilters[pill.filter])) {
        let index = selectedFilters[pill.filter].findIndex((i) => i == pill.value);
        selectedFilters[pill.filter].splice(index, 1);
      } else {
        selectedFilters[pill.filter] = null;
      }
    } else {
      delete selectedFilters[pill.filter];
    }
  }

  const documentTypeFilters = computed(() => {
    let filters = {}
    if (appliedFilters.value['documenttype'] && appliedFilters.value['documenttype'].length) {
      filters = appliedFilters.value['documenttype'].reduce((list, item) => {
        const filter = allFiltersAndOptions['documenttype'][item];
        if (filter.endpoint) {
          if (!list[filter.endpoint]) list[filter.endpoint] = []
          list[filter.endpoint].push(formatSearchField('documenttype', item, 'term'))
        };
        return list
      }, {})
    }
    if (isCategorySearch) {
      filters['product'] = [formatSearchField('documenttype', 'product', 'term')]
    }
    return filters
  })

  const appliedProductFilters = computed(() => {
    if(isGenericSearch.value || isCategorySearch.value) {
      let filterKeys = Object.keys(appliedFilters.value) // ['documenttype', 'l1_', 'l2_']
      const productFilters = filterKeys.filter(key => key !== 'documenttype') // ['l1_', 'l2_']
      const filterMap = [[formatSearchField('documenttype', 'product', 'term')]];

      // const materialFilter = filterKeys.filter(key => key === 'material');
      // let materialFilerValue = appliedFilters.value[materialFilter];
      
      // if(materialFilter.length > 0)
      // {
        
        filterMap.push(...productFilters.map(filterKey => {
          let materialValArr = [];
          materialValArr.push(appliedFilters.value[filterKey].map(item => (isRangeFilter(item)?formatSearchField('name', queryRangeValue(item), 'range'):formatSearchField('name', item, 'term'))))
          materialValArr.push(appliedFilters.value[filterKey].map(item => (isRangeFilter(item)?formatSearchField('shortdescription', queryRangeValue(item), 'range'):formatSearchField('shortdescription', item, 'term'))))
          materialValArr.push(appliedFilters.value[filterKey].map(item => (isRangeFilter(item)?formatSearchField('fulldescription', queryRangeValue(item), 'range'):formatSearchField('fulldescription', item, 'term'))))
          return materialValArr;
        }));

        // productFilters = productFilters.filter(key => key !== 'material');
      //}
      
      // filterMap.push(...productFilters.map(filterKey => {
      //   return appliedFilters.value[filterKey].map(item => (isRangeFilter(item)?formatSearchField(filterKey, queryRangeValue(item), 'range'):formatSearchField(filterKey, item, 'term')))
      // })) 
      
      if (isCategorySearch.value) {
        var filterString = defaultCategoryFilter.value
        filterMap.forEach((set) => {
          if (set.length > 1) {
            set.forEach((ele, idx) => {
              set[idx] = `(${ele.join(')(')})`; 
            })
            //filterString += `(or(${set.join(')(')}))`;
            filterString += `(or${set.join('')})`;
          } else {
            filterString += `(${set})`
          }
        })
        filterString = `(and${filterString})`

      } else {
        var filterString = ''
        if (filterMap.length > 1) {
          filterMap.forEach((set) => {
            if (set.length > 1) {
              filterString += `(or(${set.join(')(')}))`;
            } else {
              filterString += `(${set})`
            }
          })

          filterString = `(and${filterString})`
        }
        else {
          if (filterMap[0].length == 1) 
            filterString = `(${filterMap[0][0]})`
          if (filterMap[0].length > 1) 
            filterString = `(or(${filterMap[0].join(')(')}))`
        }
      }
      return filterString
    }
  })

  const appliedArticleFilters = computed(() => {
    if (!isGenericSearch.value) {
      let filterKeys = Object.keys(appliedFilters.value); // ['documenttype', 'l1_', 'l2_']
      const productFilters = filterKeys.filter((key) => key !== 'documenttype'); // ['l1_', 'l2_']
      const filterMap = [[formatSearchField('documenttype', 'blog', 'term'), formatSearchField('documenttype', 'resource', 'term'), formatSearchField('documenttype', 'catalog', 'term')]];
      filterMap.push(
        ...productFilters.map((filterKey) => {
          return appliedFilters.value[filterKey].map((item) => formatSearchField(filterKey, item, 'term'));
        }),
      );

      let filterString = '';
      if (filterMap.length > 1) {
        filterMap.forEach((set) => {
          if (set.length > 1) {
            filterString += `(or(${set.join(')(')}))`;
          } else {
            filterString += `(${set})`;
          }
        });

        filterString = `(and${filterString})`;
      } else {
        if (filterMap[0].length == 1) filterString = `(${filterMap[0][0]})`;
        if (filterMap[0].length > 1) filterString = `(or(${filterMap[0].join(')(')}))`;
      }

      return filterString;
    }
    
    else if (isArticleSearch.value) {
      let filterKeys = Object.keys(appliedFilters.value); // ['documenttype', 'l1_', 'l2_']
      const productFilters = filterKeys.filter((key) => key !== 'documenttype'); // ['l1_', 'l2_']
      const filterMap = [documentTypeFilters.value['article']];
      filterMap.push(
        ...productFilters.map((filterKey) => {
          return appliedFilters.value[filterKey].map((item) => formatSearchField(filterKey, item, 'term'));
        }),
      );

      let filterString = '';
      if (filterMap.length > 1) {
        filterMap.forEach((set) => {
          if (set.length > 1) {
            filterString += `(or(${set.join(')(')}))`;
          } else {
            filterString += `(${set})`;
          }
        });

        filterString = `(and${filterString})`;
      } else {
        if (filterMap[0].length == 1) filterString = `(${filterMap[0][0]})`;
        if (filterMap[0].length > 1) filterString = `(or(${filterMap[0].join(')(')}))`;
      }

      return filterString;
    }
  })
  
  const loadDynamicFilterConfiguration_old = () => {
    //! this isn't used any more, but it's left here for reference/testing
    const productTypeOptions = [
      'O-Rings',
      'O-Ring Cord',
      'Flange Gaskets',
      'Seals',
      'Packing Material',
      'O-Ring Kits',
      'Sealing Accessories',
      'Flat Glass',
      'Tubular Gauge Glass',
      'Annular Glass',
      'Replacement Visors',
      'Sandblast Lenses',
      'Blast Cabinet Underlayment',
      'PPE Headgear',
      'Sheet Material',
      'Respirator Cover Lenses',
      'Flat Gauge Glass',
      'Spiral Wound Gaskets',
      'Electrical Conduit Gaskets',
      'Cam & Groove Accessories',
      'Basic 8 Cam & Groove',
      'Combination Nipples',
      'Sleeves & Ferrules',
    ];

    const documentTypeOptions = [
      { label: 'Products', value: 'product', endpoint: 'product' },
      { label: 'Blogs', value: 'blog', endpoint: 'article' },
      { label: 'Resources', value: 'resource', endpoint: 'article' },
      { label: 'Catalogs', value: 'catalog', endpoint: 'article' },
    ];
    const productLineOptions = ['Sealing', 'Industrial Couplings', 'Industrial Glass', 'Plastics', 'Raw Materials'];

    const mainFilter = { type: 'checkbox', name: 'FILTER RESULTS', key: 'documenttype', expand: true, searchable: false, items: documentTypeOptions, rank: 1 };
    const productLineFilter = { type: 'checkbox', name: 'Product Categories', key: 'l1_', expand: true, searchable: false, items: productLineOptions, rank: 2 };
    const productTypeFilter = { type: 'checkbox', name: 'Product Lines', key: 'l2_', expand: true, searchable: false, items: productTypeOptions, rank: 3 };

    // these filters are commented out because they are not used in the current implementation
    // these are left here because they are good for references
    // const sliderFilter1 =   { type:'slider', name: 'Inner Diameter', expand: false, conversionType: 0, }
    // const sliderFilter2 =   { type:'slider', name: 'Working Temperature', expand: false, conversionType: 1, }
    // const checkboxFilter1 = { type:'checkbox', name: 'Product Category', key: 'l1_1', expand: false, searchable: true, conversionType: 1, items: ['Sealing', 'Industrial Couplings', 'Industrial Glass', 'Plastics', 'Raw Materials']}
    // const checkboxFilter2 = { type:'checkbox', name: 'Material', key: 'l1_2', expand: false, searchable: true, conversionType: 1, items: ['Material One', 'Material Two', 'Material Three', 'Material Four', 'Material Five', 'Material Six', 'Material Seven', 'Material Eight', 'Material Nine']}
    // const radioFilter1 =    { type:'radio', name: 'Unit of Measure', key: 'l1_3', expand: false, searchable: true, conversionType: 2, items: [{label: 'Fahrenheit', value: 'F'}, {label: 'Celsius', value: 'C'}, {label: 'Kelvin', value: 'K'},{label: 'Fahrenheit', value: 'F2'}, {label: 'Celsius', value: 'C2'}, {label: 'Kelvin', value: 'K2'}]}
    // const dropdownFilter1 = { type:'dropdown', name: 'Measure Dropdown', key: 'l1_4', expand: true, searchable: true, conversionType: 2, items: [{label: 'Fahrenheit', value: 'F'}, {label: 'Celsius', value: 'C'}, {label: 'Kelvin', value: 'K'},{label: 'Fahrenheit', value: 'F2'}, {label: 'Celsius', value: 'C2'}, {label: 'Kelvin', value: 'K2'}]}
    // const dropdownFilter2 = { type:'dropdown', name: 'Measure Dropdown2', key: 'l1_5', expand: true, searchable: true, conversionType: 2, items: ['Fahrenheit', 'Celsius', 'Kelvin', 'Fahrenheit2', 'Celsius2', 'Kelvin2' ]}

    const hardcodedFilters = [
      mainFilter,
      productLineFilter,
      productTypeFilter,
      // sliderFilter1,
      // sliderFilter2,
      // checkboxFilter1,
      // checkboxFilter2,
      // radioFilter1,
      // dropdownFilter1,
      // dropdownFilter2,
    ];

    return hardcodedFilters;
  }

  const loadDynamicFilterConfiguration = () => {
    //? The nopCommerce View should be pre-loaded with a JSON object
    //? containing the filter configuration. Here we pull it in and parse it.
    const templateFilter = { filters: [], categoryId: 0, categoryName: '', description: '', breadcrumbs: []};
    const configElement = document.getElementById('preloadedFilterConfiguration');
    const config = JSON.parse(configElement.innerHTML.trim().replace(";", ""));
    console.log(">>>>> Dynamic Filter Configuration...");
    console.log(config);
    return config || templateFilter;
  }

  const getCaptializedLabel = (label) => {
    return label
      .split(' ')
      .map((word) => {
        if (word.length > 1) return word[0].toUpperCase() + word.slice(1)
        return word.toUpperCase()
      })
      .join(' ');
  };

  const buildFacetOptions = (facetData) => {
    return Object.keys(facetData).reduce((options, key) => {
      const buckets = facetData[key].buckets || facetData[key]; 
      options[key] = [];
      options[key] = buckets.map((bucket) => {
        const option = {};
        option.value = bucket.value;
        option.label = bucket.label ? bucket.label : getCaptializedLabel(bucket.value);

        // to reduce number of queries, when they aren't needed
        // we establish an endpoint property on the filter, if the filter type
        // is `documenttype` (product or article)
        if (key === 'documenttype') {
          if (bucket.value === 'product') option.endpoint = 'product';
          else option.endpoint = 'article';
        }

        return option;
      });
      return options;
    }, {});
  };

  const getfilterItems = async (categoryId, keyMap, categoryName) => {
    let facetData = {};
    if (!categoryId) {
      console.log('getting filters from SEARCH PLATFORM')
      const { getFacetOptionList } = useSearchStore();
      facetData = await getFacetOptionList(keyMap, categoryName.value);
    }
    else {
      console.log('getting filters from FILTER ENDPOINT')
      facetData = await filterEndpoint.getFiltersByCategoryId(categoryId);
    }
    return facetData
  }

  const getSampleFilterItems = async ({ categoryId, label, value, sortBy, sortOrder, filterBy, filterByValue }) => {
    if (filterBy && filterByValue) return await filterEndpoint.getSampleFilterData(categoryId, label, value, sortBy, sortOrder, filterBy, filterByValue);
    return await filterEndpoint.getSampleFilterData(categoryId, label, value, sortBy, sortOrder);
  };
  
  async function getDynamicFilters() {
    const { filters: dynamicFilters, categoryId: id, categoryName: name, breadcrumbs: crumbs, description } = loadDynamicFilterConfiguration();
    // storing the category information into the store
    categoryId.value = id
    categoryName.value = name
    breadcrumbs.value = crumbs
    categoryDescription.value = description
    
    const keyMap = dynamicFilters.map((filter) => filter.key);

    const facetData = await getfilterItems(categoryId.value, keyMap, categoryName.value);
    
    const facetOptions = buildFacetOptions(facetData);

    dynamicFilters.forEach((filter) => {
      filter.type = filter.type.toLowerCase();
      if (facetOptions[filter.key].length > 0) filter.items = facetOptions[filter.key]
    });

    loadFilterData(dynamicFilters);

    // establish all dynamic filters with default values
    dynamicFilters.forEach((filter) => {
      if (filter.type === 'checkbox') selectedFilters[filter.key] = [];
      else if (filter.type === 'radio') selectedFilters[filter.key] = "";
      else if (filter.type === 'dropdown') selectedFilters[filter.key] = null;
      else if (filter.type === 'slider') selectedFilters[filter.key] = null;
    });

    // if we've loaded the documenttype filter, we should default all options to SELECTED
    if (selectedFilters['documenttype']) {
      selectedFilters['documenttype'].push('product', 'blog', 'resource', 'catalog');
    }
    // console.log(filtersInQuery.value,urlQuery);
    if (selectedFilters['l1_']) {
      const queryWithL1=urlQuery.query?.l1;
      const queryWithL2=urlQuery.query?.l2;
      if(queryWithL1){
        selectedFilters['l1_'].push(queryWithL1);
      }
      if(queryWithL2){
        selectedFilters['l2_'].push(queryWithL2);
      }
    }

    // load filters from query string
    const filterKeyMap = dynamicFilters.reduce((map, filter) => {
      map[filter.key] = filter
      return map
    }, {});
    const filterKeys = Object.keys(filtersInQuery.value);
    if (filterKeys.length > 0) {
      filterKeys.forEach((filterKey) => {
        if (!filterKeyMap[filterKey]) return;
        else if (filterKeyMap[filterKey]?.type === 'checkbox') selectedFilters[filterKey].push(...filtersInQuery.value[filterKey]);
        else if (filterKeyMap[filterKey]?.type === 'radio') selectedFilters[filterKey] = filtersInQuery.value[filterKey][0];
        else if (filterKeyMap[filterKey]?.type === 'dropdown') selectedFilters[filterKey] = { label: filtersInQuery.value[filterKey][0], value: filtersInQuery.value[filterKey][0] };
        else if (filterKeyMap[filterKey]?.type === 'slider') selectedFilters[filterKey] = { ...filtersInQuery.value[filterKey] };
      });
    }

    return dynamicFilters
  }

  const getNextKeyValue = (haystack) => {
    let key = '';
    let value = '';
    let pos = -1;
    pos = haystack.indexOf('%3D');
    haystack = haystack.slice(pos + 3);
    let nextStringPos = haystack.indexOf('+%27');
    let nextArrayPos = haystack.indexOf('+[%27');
    let isArray = false
    pos = nextStringPos;
    if (nextArrayPos != -1 && nextArrayPos < nextStringPos ||
        nextArrayPos != -1 && nextStringPos == -1) {
      pos = nextArrayPos;
      isArray = true;
    }
    key = haystack.slice(0, pos);
    haystack = isArray ? haystack.slice(pos + 5) : haystack.slice(pos + 4);
    // let pos1 = haystack.indexOf('%20');
    pos = isArray ?  haystack.indexOf('])') : haystack.indexOf('%27');
    // pos = pos1 > 0 && pos1 < pos2 ? pos1 : pos2;
    value = haystack.slice(0, pos);
    if (isArray) {
      value = value.replace(/%27/g, "");
    }

    return [key, value, haystack];
  };

  function parseQueryForFilters(str) {
    const json = {};
    const keyValuePairs = str.split('&');
    keyValuePairs.forEach((pair) => {
      let [key, value] = pair.split('=');
      if (key === 'fq') {
        str = str.replace(/%20/g, ' ').replace(/%26/g, '&')
        while (str.indexOf('%3D') >= 0) {
          let [key, value, newStr] = getNextKeyValue(str);
          if (value.indexOf(',') > 0) {
            json[key] = { label: value.replace(',', ' - '), value: `[${value}]`}
          }
          else {
            if (!json[key]) json[key] = [];
            json[key].push(value);
          }
          str = newStr;
        }
      }
    });
    return json;
  }
  

  const parseOutQField = () => {
    // (near+field=FIELD+distance=N+boost=N+'STRING')
    // (near+field%3DFIELD+distance%3DN+boost%3DN+%27STRING%27)
    // (near field=name distance=1 boost=2 'material')
    let string = urlQuery?.query?.q;
    if (!string) return '';
    console.log('here is the string', string);
    console.log('here is indexOf("\'")', string.indexOf('\''));
    // console.log('here is the q', q)
    // console.log('here is the q', q)
    if (string.indexOf('\'') >= 0) {
      string = string.slice(string.indexOf('\'')+1);
      console.log(string)
      string = string.slice(0, string.indexOf('\''));
    
      console.log('here is the string from parsing', string);
    }
    return string;
  };

  const buildQField = (qString) => {
    let query = ''
    query += `(term+%27${qString}%27)`
    const segments = qString.split(' ')
    let andSegments = ''
    let orSegments = ''
    if (segments.length == 1) query += `(prefix+%27${qString}%27)`
    if (segments.length > 1) {
      segments.forEach((segment) => {
        if (segment.length === 0) return
        andSegments += `(prefix+boost%3D4+%27${segment}%27)`
        orSegments += `(prefix+boost%3D2+%27${segment}%27)`
      })
      andSegments = `(and${andSegments})`
      orSegments = `(or${orSegments})`
      query += andSegments + orSegments
    }
    return query
  };

  const getMin = (items) => {
    let min = items[0].value;
    items.forEach(item => {
      if (parseInt(min) > parseInt(item.value)) {
        min = item.value;
      }
    });

    return min;
  }

  const getMax = (items) => {
    let max = items[0].value;
    items.forEach(item => {
      if (parseInt(max) < parseInt(item.value)) {
        max = item.value;
      }
    });
    return max;
  }

  const isRangeFilter = (item) => {
    try {
      if (Array.isArray(JSON.parse(item))) {
        return true;
      }
    } catch (e) {
      return false;
    }  
   
    return false;
  }

  const queryRangeValue = (item) => {
    let query = '';
    const parsedItem = JSON.parse(item);
    if (Array.isArray(JSON.parse(item))) {
      if (parsedItem.length > 0) {
        query = `['${parsedItem[0]}','${parsedItem[1]}']`;
      }
    }
    return query
  } 
  return {
    establishFilters,
    removePill,
    siteFilters,
    selectedFilters,
    filterPills,
    defaultProductFilter,
    defaultArticleFilter,
    defaultArticleReturnFields,
    loadFilterData,
    formattedFilters,
    getDynamicFilters,
    documentTypeFilters,
    isGenericSearch,
    isProductSearch,
    isArticleSearch,
    appliedProductFilters,
    appliedArticleFilters,
    breadcrumbs,
    parseOutQField,
    buildQField,
    categoryDescription,
    defaultCategoryFilter,
    isCategorySearch,
    getSampleFilterItems,
    filterCount,
  };
});
